export default "__VITE_ASSET__B5VRp0lK__"